// extracted by mini-css-extract-plugin
export default {"wrapper":"ProjectsTableTbody_wrapper__AcCy3"};